/**
 * Navigation utility functions for the SortaFriends application
 */

/**
 * Handles the SortaFriends header click navigation
 * Navigates to dashboard, sets active tab to stacks, and refreshes stacks data
 * @param {Function} navigate - React Router navigate function
 * @param {Function} setActiveTab - Optional function to set active tab (for Dashboard component)
 * @param {Function} setSelectedUser - Optional function to clear selected user
 * @param {Function} setSelectedGroup - Optional function to clear selected group  
 * @param {Function} setSelectedStack - Optional function to clear selected stack
 */
export const handleSortaFriendsClick = (navigate, setActiveTab = null, setSelectedUser = null, setSelectedGroup = null, setSelectedStack = null) => {
  // Navigate to dashboard
  navigate('/dashboard');
  
  // If we're in the Dashboard component, use direct state management
  if (setActiveTab) {
    setActiveTab('stacks');
    if (setSelectedUser) setSelectedUser(null);
    if (setSelectedGroup) setSelectedGroup(null);
    if (setSelectedStack) setSelectedStack(null);
  } else {
    // For other components, use event system
    window.dispatchEvent(new CustomEvent('navigateTab', { detail: { tab: 'stacks' } }));
  }
  
  // Always dispatch refresh event to reload stacks data
  window.dispatchEvent(new CustomEvent('refreshStacks'));
};

/**
 * Creates the onClick handler for the SortaFriends header
 * @param {Function} navigate - React Router navigate function
 * @param {Object} options - Optional state setters for Dashboard component
 * @returns {Function} onClick handler function
 */
export const createSortaFriendsClickHandler = (navigate, options = {}) => {
  return () => handleSortaFriendsClick(
    navigate,
    options.setActiveTab,
    options.setSelectedUser,
    options.setSelectedGroup,
    options.setSelectedStack
  );
};
